module.exports = __webpack_public_path__ + "static/icon_item_right.54cc9d38.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/icon_item_right.png
// module id = 1046
// module chunks = 2